import React, { useEffect, useState } from "react";
import { Avatar, Button, Row, Table, Tooltip, message } from "antd";
import { EyeOutlined, LoginOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import GetMerchants from "functions/admin/getMerchants";
import ImpersonateMerchant from "functions/admin/impersonateMerchant";
import { useLoading } from "context/loadingContext";
import AdminMerchantAdd from "components/modal/adminMerchantAdd";
import { bg_button, bg_shadow } from "constant/css";

const MerchantList = () => {
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoading();
  const [data, setData] = useState([]);
  const [impersonatingId, setImpersonatingId] = useState(null);
  const [addOpen, setAddOpen] = useState(false);

  useEffect(() => {
    fetchMerchants();
  }, []);

  const fetchMerchants = async () => {
    showLoading();
    try {
      const response = await GetMerchants();
      if (response) setData(response.data || []);
    } catch (error) {
      console.error("Error fetching merchants:", error);
    } finally {
      hideLoading();
    }
  };

  const handleImpersonate = async (record) => {
    setImpersonatingId(record.id);
    try {
      const response = await ImpersonateMerchant(record.id);
      if (!response || !response.token) {
        message.error("Нэвтрэх токен авахад алдаа гарлаа.");
        return;
      }
      const encodedData = encodeURIComponent(
        JSON.stringify(response.merchantData)
      );
      const url = `/merchant-impersonate?token=${response.token}&merchantId=${response.merchantId}&merchantData=${encodedData}`;
      window.open(url, "_blank");
    } catch (error) {
      console.error("Impersonation error:", error);
      message.error("Нэвтрэх үед алдаа гарлаа.");
    } finally {
      setImpersonatingId(null);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      width: 80,
    },
    {
      title: "Лого",
      dataIndex: "iconPath",
      key: "iconPath",
      width: 90,
      render: (iconPath, record) => (
        <Avatar
          shape="square"
          size={44}
          src={
            iconPath
              ? `https://storage.googleapis.com/smartbilling_hubilai/merchant/logo/${iconPath}`
              : "https://storage.googleapis.com/smartbilling_hubilai/logos/smartbillingbg.png"
          }
          alt={record.name}
        />
      ),
    },
    {
      title: "Мерчант",
      dataIndex: "name",
      key: "name",
      render: (value) => (
        <Tooltip title={value}>
          <span className="uppercase">{value}</span>
        </Tooltip>
      ),
    },
    {
      title: "Slogan",
      dataIndex: "slogan",
      key: "slogan",
      render: (value) => value || "-",
    },
    {
      title: "",
      key: "action",
      width: 180,
      align: "center",
      render: (_, record) => (
        <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => navigate(`/adminMerchants/${record.id}`)}
          >
            Нээх
          </Button>
          <Button
            type="link"
            icon={<LoginOutlined />}
            loading={impersonatingId === record.id}
            onClick={() => handleImpersonate(record)}
            style={{ color: "#52c41a" }}
          >
            Орох
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="vatMerchantListontainer mt-3">
      <Row style={{ marginBottom: 12 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          className={`${bg_button} ${bg_shadow} rounded-xl`}
          onClick={() => setAddOpen(true)}
        >
          Шинэ мерчант
        </Button>
      </Row>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        size="small"
        pagination={false}
        scroll={{ x: "max-content", y: "calc(100vh - 24vh)" }}
      />
      {addOpen && (
        <AdminMerchantAdd
          open={addOpen}
          close={() => setAddOpen(false)}
          refresh={fetchMerchants}
        />
      )}
    </div>
  );
};

export default MerchantList;
